<template>
  <div class="speaker-page inner">
    <site-menu theme="dark" class="menu"/>
    <div class="content">
      <speaker :details="speaker" />
    </div>
  </div>
</template>
<script>
  import SiteMenu from '@/components/SiteMenu.vue'
  import Speaker from '@/components/Speaker'
  import speakers from '@/lib/speakers'

  export default {
    name: 'speaker-page',
    components: { SiteMenu, Speaker },
    data() {
      return { index: null }
    },
    computed: {
      speaker() {
        return speakers[this.index]
      },
    },
    created() {
      this.index = this.$route.query.speakerIndex
    },
  }
</script>
<style lang="scss" scoped>
  .content {
    padding: 50px 0;
    position: relative;
    overflow: hidden;
  }
</style>
